(function()
{
	var Application = include("springroll.Application");
	var Debug = include("springroll.Debug", false);
	var Ease = include("createjs.Ease");
	var EventDispatcher = include("springroll.EventDispatcher");
	var MovieClip = include("pixiflash.MovieClip");
	var Sprite = include("PIXI.Sprite");
	var Texture = include("PIXI.Texture");
	var Tween = include("createjs.Tween");

	var BreathMeter = function(config, touchGetter)
	{
		/**
		 * The area to click/touch to start game
		 * @property {PIXI.Container} touchGetter
		 */
		this.touchGetter = touchGetter;

		/**
		 * Reference to the application
		 * @property {springroll.Application} app
		 */
		this.app = Application.instance;

		/**
		 * Breathe meter configuration
		 * @property {Object} config
		 */
		this.config = config;

		// Stop these animations
		this.anemometer.stop();
		this.windsock.stop();

		this.onMouseDown = this.onMouseDown.bind(this);
		this.autoPauseUpdate = this.autoPauseUpdate.bind(this);
		this.updateCursor = this.updateCursor.bind(this);

		/**
		 * The current animation timeline
		 * @property {springroll.AnimatorTimeline} timeline 
		 */
		this.timeline = null;
	};

	var s = MovieClip.prototype;
	var p = BreathMeter.prototype;

	// Set the position of a display object from data
	var setPosition = function(obj, data)
	{
		obj.x = data.x || 0;
		obj.y = data.y || 0;
	};

	/**
	 * The current timeline of the breathe animation
	 * @method start
	 * @param {springroll.AnimatorTimeline} timeline Current animation timeline
	 */
	p.start = function(timeline)
	{
		this.visible = true;
		this.timeline = timeline;
		this.timelineDuration = this.timeline.duration * 1000;
		this.cursor.position.y = this.config.movement.start;
		this.app.on('update', this.updateCursor);
		this.enable();
	};

	/**
	 * Update the cursor animation
	 * @method updateCursor
	 * @param {int} elapsed Update in MS since last update
	 */
	p.updateCursor = function(elapsed)
	{
		if (!this.timeline) return;

		var movement = this.config.movement;
		var start = movement.start;
		var end = movement.end;
		var transition = movement.transition;

		var progress = null;

		// Let the windsock animations finish 
		if (this.stoppedTimestamp)
		{
			progress = this.stoppedTimestamp / this.timelineDuration;
			// ~Szk: hacky way of making the animation finish forward or reverse
			this.stoppedTimestamp += elapsed * (this.stopTimelineDir);
			if (progress > 1 || progress < 0)
			{
				this.app.off('update', this.updateCursor);
			}
		}
		else
		{
			progress = this.timeline.time / this.timelineDuration;
			// Slice the cursor up and down 
			var t = null;
			if (progress < transition)
			{
				// Move the cursor up from red to green on breathing
				t = progress / transition;
				this.cursor.y = start - (start - end) * Ease[movement.easeIn](t);
			}
			else
			{
				// Move the cursor down from the green to red on exhale
				t = (progress - transition) / (1 - transition);
				this.cursor.y = end - (end - start) * Ease[movement.easeOut](t);
			}
		}

		syncTimelines(this.anemometer, progress);
		syncTimelines(this.windsock, progress);
	};

	/**
	 * @param {} clip
	 * @param {} progress
	 */
	var syncTimelines = function(clip, progress)
	{
		var frame = Math.round(progress * (clip.timeline.duration - 1));
		clip.gotoAndStop(frame);
	};

	p.enable = function()
	{
		this.touchGetter.on("touchstart", this.onMouseDown);
		this.touchGetter.on("mousedown", this.onMouseDown);
		this.app.keyboard.addKeyDown("spacebar", this.onMouseDown);
	};

	p.disable = function()
	{
		this.touchGetter.off("touchstart", this.onMouseDown);
		this.touchGetter.off("mousedown", this.onMouseDown);
		this.app.keyboard.removeKeyDown("spacebar", this.onMouseDown);
		this.app.off("update", this.autoPauseUpdate);
	};

	/**
	 * Start listening to when we get to the top of the meter
	 * @method pauseAtTopAndEnable
	 */
	p.pauseAtTopAndEnable = function()
	{
		this.app.on("update", this.autoPauseUpdate);
		this.prevPos = this.cursor.y;
		this.prevDir = null;
	};

	/**
	 * Update handler for auto-pausing at top
	 * @method autoPauseUpdate
	 * @param {int} elapsed Elapsed time in ms
	 */
	p.autoPauseUpdate = function(elapsed)
	{
		var dir = this.cursor.y < this.prevPos ? -1 : 1;
		var atTop = this.prevDir == -1 && dir == 1; // At top!
		if (atTop || this.cursor.y == this.config.movement.end)
		{
			this.cursor.y = this.config.movement.end;
			this.app.off('update', this.updateCursor);
			this.app.off('update', this.autoPauseUpdate);
			this.enable();
			this.timeline = null;
			this.emit("paused");
			return;
		}
		this.prevDir = dir;
		this.prevPos = this.cursor.y;
	};

	p.fullyEnable = function()
	{
		this.app.off("update", this.autoPauseUpdate);
		this.app.on('update', this.updateCursor);
		this.enable();
	};

	p.onMouseDown = function()
	{
		Tween.removeTweens(this.cursor);
		this.disable();

		var burstPower = this.getBurstPower();
		// Which direction should the timeline finish in (reverse or forward)
		this.stopTimelineDir = (burstPower.power > 800 ||
			this.stoppedTimestamp / this.timelineDuration > 0.25) ? 1 : -1;
		this.emit("complete", burstPower);

		// Remove reference to the timeline so the update can't continue 
		// Animating the cat blowing_loop
		this.timeline = null;
	};

	/**
	 * @param {int} powerOverride 
	 * @return {Object} Object containing `power` (number, see config)
	 * and `bucket` (0..3), used for reaction from NC
	 */
	p.getBurstPower = function(powerOverride)
	{
		var dist = powerOverride ||
			Math.abs(this.cursor.position.y - this.config.movement.end);
		var power = this.config.power;
		for (var i = power.length - 1; i >= 0; --i)
		{
			var powerItem = power[i];
			if (dist <= powerItem.maxDist)
			{
				var minDist = i == power.length - 1 ? 0 : power[i + 1].maxDist;
				// Convert into 0-1 percent for this block
				var burstPower = (dist - minDist) / (powerItem.maxDist - minDist);
				// Invert the percent so that 0 is farthest away
				burstPower = 1 - burstPower;
				// Multiply by the power to get actual power
				burstPower *= powerItem.maxPower - powerItem.minPower;
				burstPower += powerItem.minPower;

				return {
					power: burstPower,
					bucket: powerItem
				};
			}
		}
	};

	p.destroy = function()
	{
		this.app.keyboard.removeKeyDown("spacebar", this.onMouseDown);
		this.app.off('update', this.updateCursor);
		this.app.off("update", this.autoPauseUpdate);
		this.touchGetter.off("mousedown", this.onMouseDown);
		this.touchGetter.off("touchstart", this.onMouseDown);

		s.destroy.call(this, true);

		this.touchGetter = null;
		this.app = null;
		this.config = null;
		this.cursor = null;
		this.timeline = null;
		this.onMouseDown = null;
		this.autoPauseUpdate = null;
		this.updateCursor = null;
	};

	namespace("nature").BreathMeter = BreathMeter;

}());